import React, { useState } from "react";
import {
  Autocomplete,
  TextField,
  FormControl,
  FormHelperText,
} from "@mui/material";

const CustomAutocompleteField = ({
  value,
  onChange,
  placeholder,
  options,
  rule,
  disabled,
  variant,
  searchBy = "userId",
  displayField = "namaAnggota",
  onOpen, // <-- Tambahan di sini
  ...props
}) => {
  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState("");

  const handleValidation = (val) => {
    if (rule) {
      const { isValid, errorMessage } = rule(val);
      setError(!isValid);
      setHelperText(errorMessage);
    }
  };

  const handleChange = (event, newValue) => {
    // const newVal = newValue ? newValue[searchBy] : "";
    onChange(newValue);
    handleValidation(newValue);
  };

  const handleBlur = () => {
    handleValidation(value);
  };

  const formatLabel = (option) => {
    if (typeof displayField === "string" && displayField.includes("{")) {
      return displayField.replace(/{(.*?)}/g, (_, key) => {
        const val = option?.[key.trim()];
        return val !== undefined ? val : "";
      });
    }

    return option?.[displayField] || option?.namaAnggota || option?.name || "";
  };

  return (
    <FormControl fullWidth error={error}>
      <Autocomplete
        value={options.find((option) => option[searchBy] === value) || null}
        onChange={handleChange}
        onBlur={handleBlur}
        onOpen={onOpen} // <-- Tambahan di sini
        disabled={disabled}
        options={options}
        isOptionEqualToValue={(option, val) =>
          option[searchBy] === val[searchBy]
        }
        getOptionLabel={(option) => formatLabel(option)}
        renderOption={(props, option) => (
          <li {...props} key={option[searchBy]}>
            {formatLabel(option)}
          </li>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={placeholder}
            variant={variant}
            error={error}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 20,
                minHeight: { xs: "44px", sm: "54px" },
                // The root and the inner input both carry their own padding
                // here, stacked — split so the combined total lines up with
                // the other fields' single padding value, not doubles it.
                padding: { xs: "6px 55px 6px 8px !important", sm: "9px 55px 9px 9px !important" },
                ...(disabled && {
                  backgroundColor: "#E0E0E0",
                }),
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderRadius: 20,
              },
              "& .MuiOutlinedInput-input": {
                fontSize: { xs: "13px", sm: "15px" },
              },
              "& .MuiAutocomplete-input": {
                padding: { xs: "6px 6px !important", sm: "7.5px 6px !important" },
              },
              ...(disabled && {
                "& .MuiInputBase-input.Mui-disabled": {
                  WebkitTextFillColor: "unset",
                },
              }),
            }}
          />
        )}
        {...props}
      />
      {error && (
        <FormHelperText>
          {helperText || "Please select a value"}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default CustomAutocompleteField;